import { PageResponse } from '@models/page-response';
import { MainComponent } from '../main/main.component';
import { TranslateService } from '@ngx-translate/core';
import { AppConstant } from '@constants/app.constant';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { Component, ViewChild } from '@angular/core';
import { switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Group, GroupSearchingCriteria } from '@app/models/group';
import { GroupService } from '@app/services/group.service';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { OnepageTemplate } from '@app/models/onepage-template';
import { OnepageTemplateService } from '@app/services/onepage-template.service';
import { DeploymentService } from '@app/services/deployment.service';
import { Deployment, PublishSearchingCriteria } from '@app/models/deployment';

@Component({
    templateUrl: './deployment-list.component.html',
    styleUrls: ['./deployment-list.component.scss']
})
export class DeploymentListComponent {

    private searchTermStream = new Subject<string>();
    
    statusOptions: string[] = ['ENABLED', 'DISABLED'];
    
    loading: boolean = false;

    globalCriteria: string = '';
    searchingCriteria: PublishSearchingCriteria = new PublishSearchingCriteria();

    page: number = 1;
    size: number = 10;
    totalItems: number = 0;
    sortField: string;
    sortDirection: 'asc' | 'desc';
    selectedTemplateId: string;

    pagingInfo: {
        start: number;
        end: number;
        total: number;
    }

    records: Deployment[];

    constructor(private router: Router,
        private route: ActivatedRoute,
        public appConstant: AppConstant,
        private deploymentService: DeploymentService,
        private translate: TranslateService,
        private mainComponent: MainComponent) {
    }

    ngOnInit(): void {

        this.loading = true;
        this.pagingInfo = {
            start: 0,
            end: 0,
            total: 0
        }

        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.globalCriteria = params['global'] || '';
                    this.page = Number(params['page']) || 1;
                    this.sortField = params['sortField'] || 'onepageTemplateCode';
                    this.sortDirection = params['sortDirection'] || 'asc';

                    if (params['searchingCriteria'] != null) {
                        this.searchingCriteria = JSON.parse(params['searchingCriteria']);
                    } else {
                        this.searchingCriteria = new PublishSearchingCriteria();
                    }

                    return this.deploymentService.globalSearch(this.globalCriteria, this.searchingCriteria, this.page - 1, this.size, this.sortField, this.sortDirection);
                })
            )
            .subscribe((res: PageResponse<Deployment>) => {
                this.loading = false;
                this.page = res.number + 1;
                this.totalItems = res.totalElements;
                this.records = res.content;
                this.pagingInfo.start = (this.page - 1) * this.size + 1;
                this.pagingInfo.end = this.page * this.size;
                this.pagingInfo.total = this.totalItems;
                if (this.pagingInfo.end > this.pagingInfo.total) {
                    this.pagingInfo.end = this.pagingInfo.total;
                }
            });

        this.searchTermStream
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((term: string) => this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection));

    }

    deploy(templateId): void {

        this.selectedTemplateId = templateId;
        
    }
    disable(templateId:string, isDisable:boolean): void{
        
        // this.deploymentService.disable(templateId, isDisable).subscribe(response=>{
        //     console.log("RESPONSE:>>>"+response);
        //     if(response=="TRUE"){
        //         this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection);
        //     }else{

        //     }
        // });

    }

    sort(field: string): void {
        this.sortField = field;

        if (this.sortField === field) {
            this.sortDirection === 'asc' ? this.sortDirection = 'desc' : this.sortDirection = 'asc';
        } else {
            this.sortField = field;
            this.sortDirection === 'asc';
        }

        this.doSearch(this.globalCriteria, this.page, field, this.sortDirection);
    }

    ngOnDestroy(): void {
    }

    pageChange(changedPage: number): void {
        if (this.page != changedPage) {
            this.doSearch(this.globalCriteria, changedPage, this.sortField, this.sortDirection);
        }
    };

    search(term: string) {
        this.searchTermStream.next(term);
    }

    private doSearch(criteria: string, page: number, sortField: string, sortDirection: string) {
        this.records = [];
        this.loading = true;
        this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH, {
            global: criteria,
            page: page,
            sortField: sortField,
            sortDirection: sortDirection,
            searchingCriteria: JSON.stringify(this.searchingCriteria)
        }]);
    }

    
    onDeploymentSet(useOriginalUrl: boolean) {
        console.debug('task config finished '+useOriginalUrl)
        
        this.deploymentService.deploy(this.selectedTemplateId).subscribe(response=>{
            alert(response);
        });
    }




}
